var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "media-library-item",
    {
      ref: "newFolder",
      staticClass: "media-library-folder",
      attrs: {
        name: "",
        "display-name": _vm.resource("MediaLibrary_CreateFolder_DisplayName"),
        "name-editor-placeholder": _vm.resource(
          "MediaLibrary_CreateFolder_Placeholder"
        )
      },
      on: {
        "item-clicked": _vm.startEdit,
        "item-renamed": function($event) {
          return _vm.createFolder($event)
        }
      }
    },
    [_c("i", { staticClass: "fas fa-folder-plus fa-3x" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }